const rootArea = "";

export const endpointsGlob = (base: string) => ({
	self: `${base}${rootArea}`,
	byCode: (proxyCode: string) => ({ 					
		read: `${base}${rootArea}/${proxyCode}/read`, 			
		edit: `${base}${rootArea}/${proxyCode}/invoke.execute`
	})
});
